import { Swiper, Navigation, Pagination, Autoplay } from "swiper/dist/js/swiper.esm.js";

Swiper.use([Navigation, Pagination, Autoplay]);

export default () => {
    let swiper = new Swiper(".gallery-modal-slider", {
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });

    // componente de banner padrão
    let bannerDefault = new Swiper(".banner__default", {
        watchOverflow: true,
        navigation: {
            nextEl: ".banner-button-next",
            prevEl: ".banner-button-prev",
        },
        pagination: {
            el: ".banner-pagination",
            type: "bullets",
            clickable: true,
        },
    });

    let sliderMainHome = new Swiper(".slider-main-home", {
        navigation: {
            nextEl: ".main-home-button-next",
            prevEl: ".main-home-button-prev",
        },
        pagination: {
            el: ".main-home__pagination",
            clickable: true,
        },
        autoplay: {
            delay: 10000,
        },
    });

    let sliderEnterprise = new Swiper(".slider-enterprise", {
        navigation: {
            nextEl: ".enterprise-button-next",
            prevEl: ".enterprise-button-prev",
        },
        pagination: {
            el: ".enterprise__pagination",
            clickable: true,
        },
        slidesPerView: 3,
        spaceBetween: 32,
        breakpoints: {
            320: {
                slidesPerView: 1.3,
                spaceBetween: 32,
            },
            600: {
                slidesPerView: 1.3,
                spaceBetween: 32,
            },
            1200: {
                slidesPerView: 2.2,
                spaceBetween: 32,
            },
        },
    });

    let sliderBlog = new Swiper(".slider-blog", {
        navigation: {
            nextEl: ".blog-button-next",
            prevEl: ".blog-button-prev",
        },
        pagination: {
            el: ".blog-pagination",
            clickable: true,
        },
        slidesPerView: 3,
        spaceBetween: 32,
        breakpoints: {
            320: {
                slidesPerView: 1.3,
                spaceBetween: 32,
            },
            600: {
                slidesPerView: 1.3,
                spaceBetween: 32,
            },
            1200: {
                slidesPerView: 2.2,
                spaceBetween: 32,
            },
        },
    });

    let sliderGallery = new Swiper(".slider-gallery", {
        navigation: {
            nextEl: ".gallery-button-next",
            prevEl: ".gallery-button-prev",
        },
        pagination: {
            el: ".gallery__pagination",
            clickable: true,
        },
    });

    let sliderCarousel = new Swiper(".slider-carousel", {
        slidesPerView: 3,
        spaceBetween: 4,
        loop: true,
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 4,
            },
            600: {
                slidesPerView: 1,
                spaceBetween: 4,
            },
            1200: {
                slidesPerView: 3,
                spaceBetween: 4,
            },
        },
    });
};
